import { NotificationDetail } from "@/components/shared/notifications/notification-detail";
import { Redirect, useRoute } from "@/components/shared/router";
import { ClientInstance } from "@/lib/graphql/apollo";
import { ClientNotificationDetailFragmentDoc } from "@/__generated__/graphql";

export function NotificationDetailContainer({ id }: { id: string }) {
  const { push } = useRoute();

  const notification = ClientInstance.readFragment({
    id: `AppNotification:${id}`,
    fragment: ClientNotificationDetailFragmentDoc,
  });

  const handleClose = () => {
    push("/notifications");
  };

  if (!notification) {
    return <Redirect path="/notifications" />;
  }

  return (
    <NotificationDetail notification={notification} onClose={handleClose} />
  );
}
